import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { SessionProvider } from './context/SessionContext';

// Pages
import Home from './pages/Home';
import NewSession from './pages/NewSession';
import JoinSession from './pages/JoinSession';
import Rejoin from './pages/Rejoin';
import ActiveSession from './pages/ActiveSession';
import Summary from './pages/Summary';

function App() {
  return (
    <SessionProvider>
      <div className="app-container">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/session/new" element={<NewSession />} />
            <Route path="/session/join" element={<JoinSession />} />
            <Route path="/session/rejoin" element={<Rejoin />} />
            <Route path="/session/:sessionCode" element={<ActiveSession />} />
            <Route path="/session/:sessionCode/summary" element={<Summary />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </SessionProvider>
  );
}

export default App;
